import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen: React.FC = () => {
  return (
    <motion.div 
      className="loading-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
    >
      <div className="loading-content">
        <motion.img 
          src="/img/logo.svg" 
          alt="Brand Logo" 
          className="loading-logo"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 0.6,
            ease: 'easeOut'
          }}
        />
        
        <motion.div 
          className="loading-bar-container"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 0.6, 
            delay: 0.2,
            ease: 'easeOut'
          }}
        >
          <motion.div 
            className="loading-bar"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ 
              duration: 1.2, 
              ease: [0.34, 0.53, 0.37, 1],
              delay: 0.4
            }}
          />
        </motion.div>

        <motion.div
          className="loading-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.7 }}
          transition={{ 
            duration: 0.4, 
            delay: 0.7 
          }}
        >
          Loading...
        </motion.div>
      </div>
    </motion.div>
  );
};

export default LoadingScreen; 